module.exports = __webpack_public_path__ + "static/media/person-1.8fc92705.png";